import { createSelector } from 'reselect'
import { getEntityMap, getListState } from 'data'

export const NOTE_ACTIVITIES_LIST_NAME = 'noteActivities'

export const getAllNoteActivities = state => getEntityMap(state, 'NoteActivity')
export const getNoteActivity = (state, noteActivityId) =>
  getEntityMap(state, 'NoteActivity').get(noteActivityId)

export const getAllNoteActivitiesListState = getListState(
  NOTE_ACTIVITIES_LIST_NAME
)

export const getAllNoteActivitiesIds = state =>
  getAllNoteActivitiesListState(state).nodes

export const getNoteActivities = createSelector(
  getAllNoteActivities,
  (_, noteId) => noteId,
  (noteActivities, noteId) =>
    noteActivities
      .filter(noteActivity => noteActivity.get('noteId') === noteId)
      .sort((a, b) => {
        return new Date(b.get('createdAt')) - new Date(a.get('createdAt'))
      })
)
